export const MapKey = "AIzaSyB3mMuvl8IUlviRZiizBiX7uhsdIqunx94";
